package org.solyton.solawi.bid.application.ui.page.user.`data`

import kotlin.Boolean
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated Lens.
 * Read and manipulate [UiStateOfOrganizationPage.isMemberListOpened]
 */
@ReadWrite
public val isMemberListOpened: Lens<UiStateOfOrganizationPage, Boolean> by lazy {
      Lens(
        get = { whole -> whole.isMemberListOpened },
        set = { part -> { whole -> whole.copy(isMemberListOpened = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiStateOfOrganizationPage.isMemberListOpened]
 */
@ReadWrite
public fun UiStateOfOrganizationPage.isMemberListOpened(`set`: Boolean.() -> Boolean):
    UiStateOfOrganizationPage = copy(isMemberListOpened = set(isMemberListOpened))

/**
 * Autogenerated Lens.
 * Read and manipulate [UiStateOfOrganizationPage.isApplicationListOpened]
 */
@ReadWrite
public val isApplicationListOpened: Lens<UiStateOfOrganizationPage, Boolean> by lazy {
      Lens(
        get = { whole -> whole.isApplicationListOpened },
        set = { part -> { whole -> whole.copy(isApplicationListOpened = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiStateOfOrganizationPage.isApplicationListOpened]
 */
@ReadWrite
public fun UiStateOfOrganizationPage.isApplicationListOpened(`set`: Boolean.() -> Boolean):
    UiStateOfOrganizationPage = copy(isApplicationListOpened = set(isApplicationListOpened))
